module.exports = __webpack_public_path__ + "img/8.ab5e3ecb.jpg";